import { useTranslation } from '@gem/modules/i18n';

import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';

import usePresenter from './presenter';

const Advertisement = ({
  titleClassName,
  textClassName,
  iconClassName,
  message,
  title,
  onClick,
  preventInteraction,
}) => {
  const imageUrl = usePresenter({ message });
  const { t } = useTranslation();

  if (!message) {
    return null;
  }

  return (
    <MiniatureMessageLayout
      titleClassName={titleClassName}
      textClassName={textClassName}
      iconClassName={iconClassName}
      imageUrl={imageUrl}
      title={title}
      text={t('common_advertising')}
      messageId={message.id}
      onClick={onClick}
      preventInteraction={preventInteraction}
    />
  );
};

export default Advertisement;
